import { ApiCompany } from "./company.model";
import { ApiContact } from "./contact.model";
import { ApiModel } from "./model.model";

export class ApiCase extends ApiModel {
    Company: ApiCompany;
    Contact: ApiContact;
    company_ID: string;
    contact_ID: string;
    case_number: string;
    subject: string;
    call_back_date: string;
    call_back_type: string;
    status: string;
    priority: string;
    type: string;
    sub_type: string;
    due_date: string;
    resolution: string;
    origin: string;
    description: string;
    notes: string; 
    datetime_notified: string;
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/case.model.ts